import { Box, Card, CardContent, CardHeader, IconButton } from "@mui/material";
import PlanDetails from "./PlanDetails";
import FloorDiagram from "./FloorDiagram";
import CLOSE_ICON from "../../images/close.svg";
import MAGNI_PLUS_ICON from "../../images/magni-plus.svg";
import MAGNI_MINUS_ICON from "../../images/magni-minus.svg";
import { useState } from "react";

const styles = {
  container: {
    position: "absolute",
    top: "56px",
    right: "-24px",
    background: "#fff",
    borderRadius: "12px 0 0 12px",
    padding: "10px",
    maxWidth: "900px",
  },
};

const containerStyle = [
  { width: "700px", height: "calc(100vh - 93px)" },
  { width: "900px", height: "calc(100vh - 93px)" },
];

const FloorPlan = ({
  selectedRoom,
  selectedFloor,
  grid,
  plan,
  floorPlans,
  openMap,
  setOpenMap,
  onRoomSelect,
  nameMap,
}) => {
  const [isLargeContainer, setIsLargeContainer] = useState(false);
  return (
    <Card
      sx={{
        ...styles.container,
        width: isLargeContainer ? containerStyle[1] : containerStyle[0],
        zIndex: 999,
      }}
      className="scale-in-right-animation"
    >
      <CardHeader
        sx={{ padding: "5px 10px" }}
        title={
          <Box
            sx={{
              fontSize: "16px",
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            Floor Plan
          </Box>
        }
        action={
          <>
            <IconButton aria-label="close" onClick={() => setOpenMap(false)}>
              <img src={CLOSE_ICON} alt="Close" />
            </IconButton>
          </>
        }
      />
      <CardHeader
        sx={{ padding: "5px 10px" }}
        title={
          <Box
            sx={{
              fontSize: "16px",
              display: "flex",
              alignItems: "center",
            }}
          >
            <PlanDetails
              grid={grid}
              plan={plan}
              isLargeContainer={isLargeContainer}
            />
          </Box>
        }
      />
      <button
        onClick={() => setIsLargeContainer(!isLargeContainer)}
        className="header-btn"
        style={{
          position: "absolute",
          zIndex: 1,
          right: "20px",
          padding: "7px",
          marginTop: "20px",
        }}
      >
        {isLargeContainer ? (
          <img src={MAGNI_MINUS_ICON} alt="Magnify Minus" />
        ) : (
          <img src={MAGNI_PLUS_ICON} alt="Magnify Plus" />
        )}
      </button>
      <CardContent
        className="iframe-container"
        sx={{
          height: isLargeContainer ? "calc(100% - 61px)" : "calc(100% - 121px)",
          padding: "0 !important",
          position: "relative",
          overflow: "auto",
        }}
      >
        <div
          style={{
            height: "100%",
            textAlign: "center",
            position: "relative",
            transform: `scale(${isLargeContainer ? 1 : 0.777})`,
            transformOrigin: "0 center",
          }}
        >
          <FloorDiagram
            selectedRoom={selectedRoom}
            nameMap={nameMap}
            plan={floorPlans?.find(
              (f) => f.name?.toLowerCase() === selectedFloor?.toLowerCase()
            )}
            onRoomSelect={(e) => {
              onRoomSelect(e);
              setOpenMap(!openMap);
            }}
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default FloorPlan;
